import React, { createContext, useContext, useState, ReactNode } from "react";

// Define context type
interface NetworkItem {
  key: any;
  value: string;
  default?: boolean;
}

interface NetworkContextType {
  selectedNetwork: NetworkItem;
  setSelectedNetwork: (network: NetworkItem) => void;
}

// Create context
const NetworkContext = createContext<NetworkContextType | undefined>(undefined);

// Create provider
export const NetworkProvider = ({ children }: { children: ReactNode }) => {
  const defaultNetwork: NetworkItem = { key: '', value: '' };

  const [selectedNetwork, setSelectedNetwork] = useState<NetworkItem>(defaultNetwork);

  console.log(selectedNetwork, "called initially");

  return (
    <NetworkContext.Provider value={{ selectedNetwork, setSelectedNetwork }}>
      {children}
    </NetworkContext.Provider>
  );
};

// Custom hook
export const useNetwork = (): NetworkContextType => {
  const context = useContext(NetworkContext);
  if (!context) {
    throw new Error("useNetwork must be used within a NetworkProvider");
  }
  return context;
};